import axios from "axios";
import {
  Sonic_GetCountries_URL,
  Sonic_GetStates_URL,
  Sonic_GetCities_URL,
  Sonic_GetAreas_URL,
} from "./config";

// This function fetches the list of countries from the Sonic API
export const getCountries = async (token) => {
  try {
    const response = await axios.get(Sonic_GetCountries_URL, {
      params: { customerToken: token },
    });
    console.log("Countries fetched from Service", response.data.data);
    return response.data.data;
  } catch (error) {
    console.error("Error fetching countries: ", error.message);
  }
};

// This function fetches the list of states for a given country from the Sonic API
export const getStates = async (countryId, token) => {
  try {
    const response = await axios.get(Sonic_GetStates_URL, {
      params: { countryId: countryId, customerToken: token },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching states: ", error.message);
  }
};

// This function fetches the list of cities for a given state from the Sonic API
export const getCities = async (stateId, token) => {
  try {
    const response = await axios.get(Sonic_GetCities_URL, {
      params: { stateId: stateId, customerToken: token },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching cities: ", error.message);
  }
};

// This function fetches the list of areas for a given city from the Sonic API
export const getAreas = async (cityId, token) => {
  try {
    // console.log(cityId);
    // console.log(token);
    const response = await axios.get(Sonic_GetAreas_URL, {
      params: { cityId: cityId, customerToken: token },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching areas: ", error.message);
  }
};
